module.exports = function (WaveformData, Utils) {
    'use strict';
    var isXhr2 = 'withCredentials' in new XMLHttpRequest();
    function WaveformBuilder(peaks) {
        this._peaks = peaks;
    }
    WaveformBuilder.prototype.init = function (options, callback) {
        if (options.dataUri && (options.webAudio || options.audioContext) || options.waveformData && (options.webAudio || options.audioContext) || options.dataUri && options.waveformData) {
            callback(new TypeError('Peaks.init(): You may only pass one source (webAudio, dataUri, or waveformData) to render waveform data.'));
            return;
        }
        if (options.audioContext) {
            this._peaks.logger('Peaks.init(): The audioContext option is deprecated, please pass a webAudio object instead');
            options.webAudio = { audioContext: options.audioContext };
        }
        if (options.dataUri) {
            return this._getRemoteWaveformData(options, callback);
        } else if (options.waveformData) {
            return this._buildWaveformFromLocalData(options, callback);
        } else if (options.webAudio) {
            if (options.webAudio.audioBuffer) {
                return this._buildWaveformDataFromAudioBuffer(options, callback);
            } else {
                return this._buildWaveformDataUsingWebAudio(options, callback);
            }
        } else {
            callback(new Error('Peaks.init(): You must pass an audioContext, or dataUri, or waveformData to render waveform data'));
        }
    };
    WaveformBuilder.prototype._getRemoteWaveformData = function (options, callback) {
        var self = this;
        var dataUri = null;
        var requestType = null;
        var url;
        if (Utils.isObject(options.dataUri)) {
            dataUri = options.dataUri;
        } else if (Utils.isString(options.dataUri)) {
            dataUri = {};
            dataUri[options.dataUriDefaultFormat || 'json'] = options.dataUri;
        } else {
            callback(new TypeError('Peaks.init(): The dataUri option must be an object'));
            return;
        }
        [
            'ArrayBuffer',
            'JSON'
        ].some(function (connector) {
            if (window[connector]) {
                requestType = connector.toLowerCase();
                url = dataUri[requestType];
                return Boolean(url);
            }
        });
        if (!url) {
            callback(new Error('Peaks.init(): Unable to determine a compatible dataUri format for this browser'));
            return;
        }
        var xhr = self._createXHR(url, requestType, options.withCredentials, function (event) {
            if (this.readyState !== 4) {
                return;
            }
            if (this.status !== 200) {
                callback(new Error('Unable to fetch remote data. HTTP status ' + this.status));
                return;
            }
            var waveformData = WaveformData.create(event.target.response);
            if (waveformData.channels !== 1 && waveformData.channels !== 2) {
                callback(new Error('Peaks.init(): Only mono or stereo waveforms are currently supported'));
                return;
            }
            callback(null, waveformData);
        }, function () {
            callback(new Error('XHR Failed'));
        });
        xhr.send();
    };
    WaveformBuilder.prototype._buildWaveformFromLocalData = function (options, callback) {
        var waveformData = null;
        var data = null;
        if (Utils.isObject(options.waveformData)) {
            waveformData = options.waveformData;
        } else {
            callback(new Error('Peaks.init(): The waveformData option must be an object'));
            return;
        }
        if (Utils.isObject(waveformData.json)) {
            data = waveformData.json;
        } else if (Utils.isArrayBuffer(waveformData.arraybuffer)) {
            data = waveformData.arraybuffer;
        }
        if (!data) {
            callback(new Error('Peaks.init(): Unable to determine a compatible waveformData format'));
            return;
        }
        try {
            var createdWaveformData = WaveformData.create(data);
            if (createdWaveformData.channels !== 1 && createdWaveformData.channels !== 2) {
                callback(new Error('Peaks.init(): Only mono or stereo waveforms are currently supported'));
                return;
            }
            callback(null, createdWaveformData);
        } catch (err) {
            callback(err);
        }
    };
    WaveformBuilder.prototype._buildWaveformDataUsingWebAudio = function (options, callback) {
        var self = this;
        var audioContext = window.AudioContext || window.webkitAudioContext;
        if (!(options.webAudio.audioContext instanceof audioContext)) {
            callback(new TypeError('Peaks.init(): The webAudio.audioContext option must be a valid AudioContext'));
            return;
        }
        var webAudioOptions = options.webAudio;
        if (webAudioOptions.scale !== options.zoomLevels[0]) {
            webAudioOptions.scale = options.zoomLevels[0];
        }
        var mediaSourceUrl = self._peaks.options.mediaElement.currentSrc;
        if (mediaSourceUrl) {
            self._requestAudioAndBuildWaveformData(mediaSourceUrl, webAudioOptions, options.withCredentials, callback);
        } else {
            self._peaks.once('player.canplay', function () {
                self._requestAudioAndBuildWaveformData(self._peaks.options.mediaElement.currentSrc, webAudioOptions, options.withCredentials, callback);
            });
        }
    };
    WaveformBuilder.prototype._buildWaveformDataFromAudioBuffer = function (options, callback) {
        var webAudioOptions = options.webAudio;
        if (webAudioOptions.scale !== options.zoomLevels[0]) {
            webAudioOptions.scale = options.zoomLevels[0];
        }
        var webAudioBuilderOptions = {
            audio_buffer: webAudioOptions.audioBuffer,
            split_channels: webAudioOptions.multiChannel,
            scale: webAudioOptions.scale
        };
        WaveformData.createFromAudio(webAudioBuilderOptions, callback);
    };
    WaveformBuilder.prototype._requestAudioAndBuildWaveformData = function (url, webAudio, withCredentials, callback) {
        var self = this;
        if (!url) {
            self._peaks.logger('Peaks.init(): The mediaElement src is invalid');
            return;
        }
        var xhr = self._createXHR(url, 'arraybuffer', withCredentials, function (event) {
            if (this.readyState !== 4) {
                return;
            }
            if (this.status !== 200) {
                callback(new Error('Unable to fetch remote data. HTTP status ' + this.status));
                return;
            }
            var webAudioBuilderOptions = {
                audio_context: webAudio.audioContext,
                array_buffer: event.target.response,
                split_channels: webAudio.multiChannel,
                scale: webAudio.scale
            };
            WaveformData.createFromAudio(webAudioBuilderOptions, callback);
        }, function () {
            callback(new Error('XHR Failed'));
        });
        xhr.send();
    };
    WaveformBuilder.prototype._createXHR = function (url, requestType, withCredentials, onLoad, onError) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        if (isXhr2) {
            try {
                xhr.responseType = requestType;
            } catch (e) {
            }
        }
        xhr.onload = onLoad;
        xhr.onerror = onError;
        if (isXhr2 && withCredentials) {
            xhr.withCredentials = true;
        }
        return xhr;
    };
    return WaveformBuilder;
}(require('waveform-data'), require('./utils'));